import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { css } from 'react-emotion';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { actions as termActions } from '../../../reducers/terms';
import TermStatus from '../../../constants/termStatus';
import { cx } from 'emotion';
import { useAsyncCallback } from 'react-async-hook';
import Spinner from '@cimpress/react-components/lib/shapes/Spinner';
import { fetchFulfillerPricingArch } from '../../../reducers/identities';
import { PRICING_ARCH_V2 } from '../../../constants/priceArchs';

const buttonPadding = css`
  padding: 4px 0px !important;
`;

const buttonTextStyling = css`
  width: 115px;
  white-space: normal;
`;

function ActionsCell(props) {
  const { t, term, updateTermStatus, fetchFulfillerPricingArch, pricingArchDictionary } = props;
  const [isFulfillerMovedToV2, setIsFulfillerMovedToV2] = useState(false);
  const [fulfillerArchStatusLoading, setFulfillerArchStatusLoading] = useState(true);
  const hasAcceptorPermission = term.userHasAuthorizationFor.acceptor;
  const approveTerm = () => {
    return updateTermStatus(term.termId, term.revisionId, TermStatus.APPROVED, true);
  };

  useEffect(
    () => {
      if (pricingArchDictionary[term.seller.accountId] === undefined) {
        fetchFulfillerPricingArch(term.seller.accountId);
      } else {
        pricingArchDictionary[term.seller.accountId] === PRICING_ARCH_V2
          ? setIsFulfillerMovedToV2(true)
          : setIsFulfillerMovedToV2(false);
        setFulfillerArchStatusLoading(false);
      }
    },
    [pricingArchDictionary[term.seller.accountId]]
  );
  const { execute, loading } = useAsyncCallback(approveTerm);

  if (term.status === TermStatus.PENDING && hasAcceptorPermission) {
    return fulfillerArchStatusLoading ? (
      <Spinner size={24} />
    ) : (
      <Button
        className={cx('btn btn-primary', buttonPadding)}
        onClick={execute}
        disabled={loading || isFulfillerMovedToV2}>
        {loading ? (
          <div
            title={isFulfillerMovedToV2 ? t('createContract:getStarted.sellerInPricingArchV2MessageTooltip') : null}
            className={buttonTextStyling}>
            {t('contractActions:approving')}...
          </div>
        ) : (
          <div
            title={isFulfillerMovedToV2 ? t('createContract:getStarted.sellerInPricingArchV2MessageTooltip') : null}
            className={buttonTextStyling}>
            {t('contractActions:approve')}
          </div>
        )}
      </Button>
    );
  }

  return (
    <Link to={`/${term.termId}/${term.revisionId}`}>
      <Button className={cx('btn btn-default', buttonPadding)}>
        {<div className={buttonTextStyling}>{t('contractActions:viewPricing')}</div>}
      </Button>
    </Link>
  );
}

ActionsCell.propTypes = {
  term: PropTypes.object.isRequired
};

const mapStateToProps = store => {
  return {
    pricingArchDictionary: store.identities.fulfillers.pricingArchDictionary
  };
};

const mapDispatchToProps = {
  updateTermStatus: termActions.updateTermStatus,
  fetchFulfillerPricingArch: fetchFulfillerPricingArch
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActionsCell));
